import Tray from '@components/containers/tray';
import { Body, Heading2 } from '@components/utils/text';
import { COMMON } from '@constants';
import styled from '@emotion/styled';
import { FormShape } from '@enums';
import { useFormModalSubmit } from '@hooks';
import { Button, VStack } from '@lib/uikit';
import { CustomFormModalProps } from '@types';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';

import { RenderFormModalComponent } from './RenderFormModalComponent';

interface Props extends Omit<CustomFormModalProps, 'render'> {}

const Text = styled(Body)`
    font: ${(props) => props.theme.fonts.subtitle4};
`;

export const CustomFormModal = ({
    name,
    UID,
    defaultContent,
    elements,
    formName,
    formUID,
    formType,
    formContext,
    isProductRegistration,
    customerInputType,
    isOpen,
    onClose,
}: Props) => {
    const { t } = useTranslation(COMMON);
    const [submitError, setSubmitError] = useState(false);

    const { isSubmitting, onSubmit } = useFormModalSubmit({
        modalName: name,
        modalUID: UID,
        formName,
        formUID,
        formType,
        formContext,
        formShape: FormShape.Modal,
        isProductRegistration,
        onSuccess: () => handleClose(),
        onError: () => setSubmitError(true),
    });

    const handleClose = (): void => {
        onClose();
        setSubmitError(false);
    };

    return (
        <Tray isOpen={isOpen} onClose={handleClose}>
            {submitError ? (
                <VStack align='center' textAlign='center'>
                    <Heading2>{t('form_modal_error.title')}</Heading2>
                    <Text>{t('form_modal_error.description')}</Text>
                    <Button
                        isFullWidth
                        buttonSize='large'
                        colorScheme='black'
                        onClick={() => handleClose()}
                    >
                        {t('close')}
                    </Button>
                </VStack>
            ) : (
                <VStack spacing='sm'>
                    {defaultContent}
                    {elements.map((element, index) => (
                        <RenderFormModalComponent
                            key={index}
                            component={element}
                            customerInputType={customerInputType}
                            isSubmitting={isSubmitting}
                            onSubmit={onSubmit}
                            onCloseModal={handleClose}
                        />
                    ))}
                </VStack>
            )}
        </Tray>
    );
};
